import { useEffect, useState } from "react";

/**
 * Mesure le nombre de colonnes CSS Grid d'un conteneur et renvoie
 * le nombre d'éléments "fillers" nécessaires pour compléter la dernière ligne.
 *
 * @param {React.RefObject<HTMLElement>} ref
 * @param {number} count - nombre d'items réels dans la grille
 * @returns {number} nombre de fillers à insérer (0 si la grille tombe juste)
 */
export function useGridFillers(ref, count) {
  const [cols, setCols] = useState(1);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const measure = () => {
      const tracks = window.getComputedStyle(el).gridTemplateColumns;
      const n = tracks.split(" ").filter(Boolean).length;
      setCols(n > 0 ? n : 1);
    };

    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    window.addEventListener("resize", measure);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, [ref]);

  if (count <= 0) return 0;
  return (cols - (count % cols)) % cols;
}
